module.exports = __webpack_public_path__ + "static/img/1.ce840c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/honor/1.png
// module id = H7R7
// module chunks = 1